import "./index.css";
import kxwlogo from "../../images-optimized/kxwlogo.webp";
import ImageCarousel from "../../containers/ImageCarousel";

export function Portfolio() {
  return (
    <div className="portfolio-container">
      <Navbar />
      <div>
      <ImageCarousel />
      </div>
    </div>
  );
}


function Navbar() {
  return (
    <div className="backlink">
    <a href="https://kumoxworld.com/" style={styles.link}>
    <nav style={styles.nav}>
    
      <img src={kxwlogo} style={styles.image} />
        <h1 style={styles.logo}>Back to main site</h1>
        </nav>
      </a>
    </div>
  );
}

const styles = {
  nav: {
    display: "flex",
    // justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem 2rem",
    // backgroundColor: "rgb(135, 187, 184)",
    color: "#676362",
  },
  logo: {
    fontSize: "1.5rem",
  },
  navLinks: {
    listStyle: "none",
    display: "flex",
    gap: "1.5rem",
  },
  link: {
    color: "white",
    textDecoration: "none",
  },
  image: {
    height: "60px"
  }
};